import React from 'react';
import { motion } from 'framer-motion';
import ContactForm from '../components/ContactForm';

const Contact = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 }
    }
  };

  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-100px" }}
      variants={containerVariants}
      className="max-w-2xl"
    >
      {/* Header */}
      <motion.div variants={itemVariants} className="mb-12">
        <h2 className="text-3xl font-semibold text-white-1 mb-4">
          Get In <span className="gradient-text">Touch</span>
        </h2>
        <div className="w-12 h-0.5 bg-accent-yellow rounded-full mb-6"></div>
        <p className="text-light-gray/80 leading-relaxed">
          I'm always interested in new opportunities and exciting projects. 
          Feel free to reach out!
        </p>
      </motion.div>

      {/* Contact Form */}
      <motion.div variants={itemVariants}>
        <ContactForm />
      </motion.div>
    </motion.div>
  );
};

export default Contact;
